import request from '@/utils/http';

/** 登录 */
// export const login = (data: object) => {
//   return request.post('/mock/api/login', data);
// };

export const login = (data: object) => {
  return request.post('/admin/login/account', data);
};

/** 登录 */
// export const getUserInfo = () => {
//   return request.get('/mock/api/userInfo');
// };

export const getUserInfo = () => {
  return request.post('/admin/user/info');
};

/** 获取全部页面按钮权限 */
export const getPageBtnPermission = (): Promise<App.RequestResult> => {
  return request.post('/admin/company/resource/pagePermission/AllList');
};

/** 根据角色id获取页面按钮权限 */
export const getPageBtnPermissionByRoleId = (data: object): Promise<App.RequestResult> => {
  return request.post('/admin/company/resource/pagePermission/getByRoleId', data);
};

/** 获取tree菜单列表 */
export const getMenuList = (): Promise<App.RequestResult> => {
  return request.get('/mock/api/menuList');
};
